module.exports = __webpack_public_path__ + "img/tribunais.25e07184.png";